import React from "react";

export default function getBlackAsterisk(required) {
  if (required) {
    return <span className="black-asterisk">*</span>;
  }
  return null;
}
